/**
 * apps/ddx entry — OE-DDX-UI-001.
 *
 * OA-06 Feature Flag seam: `featureFlags` is imported from ./config and
 * available for a future controlled-rollout check. This OE does not gate
 * any screen on it (architectural preparedness only).
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@axisnode/ui/styles.css";
import { featureFlags } from "./config";
import { App } from "./App";

// Reserved seam — touch point for a future flag without restructuring.
void featureFlags;

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
